import { apiClient, unwrap } from './client';

import type { ApiResponse, JobOut, MySubmissionOut, SubmissionOut } from '@/types';

export interface JobListParams {
  page?: number;
  limit?: number;
  status?: string;
  class_id?: number;
}

export interface JobListResponse {
  items: JobOut[];
  total: number;
}

export interface JobDetailResponse {
  job: JobOut;
  submissions: SubmissionOut[];
  my_submission?: MySubmissionOut | null;
  submitted_count?: number;
  class_member_count?: number;
}

export async function listJobs(params: JobListParams = {}): Promise<JobListResponse> {
  const response = await apiClient.get<ApiResponse<JobListResponse>>('/jobs', { params });
  return unwrap(response);
}

export async function createJob(formData: FormData): Promise<{ job_id: number }> {
  const response = await apiClient.post<ApiResponse<{ job_id: number }>>('/jobs', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return unwrap(response);
}

export async function getJob(id: number): Promise<JobDetailResponse> {
  const response = await apiClient.get<ApiResponse<JobDetailResponse>>(`/jobs/${id}`);
  return unwrap(response);
}

export async function submitJob(id: number, formData: FormData): Promise<{ submission_id: number }> {
  const response = await apiClient.post<ApiResponse<{ submission_id: number }>>(
    `/jobs/${id}/submit`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return unwrap(response);
}

export async function publishJob(id: number): Promise<{ ok: boolean }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean }>>(`/jobs/${id}/publish`);
  return unwrap(response);
}

/** 教师编辑作业（标题/描述/截止时间等；已有提交时后端锁定评分口径字段） */
export async function updateJob(id: number, formData: FormData): Promise<{ job_id: number }> {
  const response = await apiClient.put<ApiResponse<{ job_id: number }>>(`/jobs/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return unwrap(response);
}

/** 教师删除作业（级联删除提交与批阅数据） */
export async function deleteJob(id: number): Promise<{ ok: boolean }> {
  const response = await apiClient.delete<ApiResponse<{ ok: boolean }>>(`/jobs/${id}`);
  return unwrap(response);
}


/** 教师更新参考答案 / 是否向学生开放 */
export async function updateJobReference(
  id: number,
  data: { reference_answer?: string; show_reference?: boolean },
): Promise<{ ok: boolean }> {
  const response = await apiClient.patch<ApiResponse<{ ok: boolean }>>(
    `/jobs/${id}/reference`,
    data,
  );
  return unwrap(response);
}

/** 教师更新 / 延长作业截止时间 */
export async function updateJobDueDate(
  id: number,
  dueDate: string,
): Promise<{ ok: boolean; due_date: string }> {
  const response = await apiClient.patch<ApiResponse<{ ok: boolean; due_date: string }>>(
    `/jobs/${id}/due-date`,
    { due_date: dueDate },
  );
  return unwrap(response);
}
